import Rails from '@rails/ujs'

document.addEventListener("turbolinks:load", function() {

  const loadingHTML = "<div role='status' class='grid justify-items-center py-8'>"+
                     "<svg aria-hidden='true' class='w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600' viewBox='0 0 100 101' fill='none' xmlns='http://www.w3.org/2000/svg'>"+
                     "<path d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z' fill='currentColor'/>"+
                     "<path d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z' fill='currentFill'/>"+
                     "</svg>"+
                     "<span class='sr-only'>Loading...</span>"+
                     "</div>";

  const submitProductForm = document.getElementById('submitProduct');
  const productConfirmDialog = document.getElementById('productConfirm');
  const productTitleInput = document.getElementById('productTitle');


  const documentAttachmentInput = document.getElementById('documentAttachment');
  const documentFileNameInput = document.getElementById('documentFileName');
  const submitDocumentForm = document.getElementById('submitDocument');
  const documentConfirmDialog = document.getElementById('documentConfirm');
  const documentVersionsDialog = document.getElementById('documentVersions');
  const documentVersionsBody = document.getElementById('documentVersionsBody');

  if(documentAttachmentInput && documentFileNameInput){
    documentAttachmentInput.addEventListener('change', function(event){
      if(documentAttachmentInput.files[0] && documentId == ''){
        documentFileNameInput.value = documentAttachmentInput.files[0].name.replace(/ /g,"_");
      }
    });
  }

  if(submitDocumentForm && documentFileNameInput){
    submitDocumentForm.addEventListener('submit', function(event){
      if(documentFileName != '' && documentFileName != documentFileNameInput.value){
        showConfirmDocumentDialog()
        event.preventDefault();
      }
    });

  }

  if(submitProductForm && productTitleInput){
    submitProductForm.addEventListener('submit', function(event){
      if(productId != '' && productTitle != '' && productTitle != productTitleInput.value){
        showConfirmProductDialog()
        event.preventDefault();
      }
    });

  }

  window.showConfirmProductDialog = function(){
    productConfirmDialog.classList.remove('hidden');
    document.getElementById('confirmBtn').focus();
  }
  window.closeConfirmProductDialog = function(){
    productConfirmDialog.classList.add('hidden');
  }
  window.confirmProductTitle = function(){
    document.getElementById('confirmBtnStatus').classList.remove('hidden');
    document.getElementById('confirmBtnTxt').classList.add('hidden');
    document.getElementById('confirmBtn').disabled = true
    document.getElementById('confirmCancelBtn').disabled = true
    submitProductForm.submit();
  }

  window.showConfirmDocumentDialog = function(){
    documentConfirmDialog.classList.remove('hidden');
    document.getElementById('confirmBtn').focus();
  }
  window.closeConfirmDocumentDialog = function(){
    documentConfirmDialog.classList.add('hidden');
  }
  window.confirmDocumentFileName = function(){
    document.getElementById('confirmBtnStatus').classList.remove('hidden');
    document.getElementById('confirmBtnTxt').classList.add('hidden');
    document.getElementById('confirmBtn').disabled = true
    document.getElementById('confirmCancelBtn').disabled = true
    submitDocumentForm.submit();
  }
  window.copyDocumentUrl = function(path){
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(window.location.origin + path);
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = (window.location.origin + path);
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
      document.body.removeChild(textArea);
    }
  }
  window.showDocumentVersions = function(path, title){
    document.getElementById('documentVersionsTitle').innerHTML = title
    documentVersionsDialog.classList.remove('hidden');
    document.getElementById('documentVersionsBody').innerHTML = loadingHTML; 
    Rails.ajax({
      url: path,
      type: "get",
      dataType:"script",
      success: function(data) { 
      },
      error: function(event, xhr, data){
        console.log(">>>>>>>>> error")
        console.log(xhr)
        console.log(data)
        if(data.status == 401){
          window.location.reload()
        } else {
          alert("Failed to load document versions. Please try again later")
        }
      },
    })
  }
  window.closeDocumentVersionsDialog = function(){
    documentVersionsDialog.classList.add('hidden');
  }

  window.downloadDocumentVersion = function(documentVersionId, path, fileName){
    document.getElementById('documentVersionDownloading-'+ documentVersionId).classList.remove('hidden');
    document.getElementById('documentVersionDownload-'+ documentVersionId).classList.add('hidden');
    Rails.ajax({
      url: path,
      type: "get",
      success: function(data) { 
        var attachmentFile = window.URL.createObjectURL(new Blob([data]));
        var docUrl = document.createElement('a');
        docUrl.href = attachmentFile;
        docUrl.setAttribute('target', '_blank');
        docUrl.setAttribute('download', fileName);
        //document.body.appendChild(docUrl);
        docUrl.click();
        URL.revokeObjectURL(attachmentFile);
      },
      error: function(event, xhr, data){
        console.log(">>>>>>>>> error")
        console.log(xhr)
        console.log(data)
        if(data.status == 401){
          window.location.reload()
        } else {
          alert("Failed to download document version. Please try again later")
        }
      },
      complete: function(data){
        document.getElementById('documentVersionDownload-'+ documentVersionId).classList.remove('hidden');
        document.getElementById('documentVersionDownloading-'+ documentVersionId).classList.add('hidden');
      }
    })
    return false;
  }

});